import { defaultLocale } from '@sola/contentful-model/lib/locales.js';
import { LOCALES_CODES } from '@sola/contentful-model/lib/types.js';

export const i18nConfig = {
  // locales: Object.values(LOCALES_CODES.enum),
  locales: [LOCALES_CODES.enum.en],
  defaultLocale,
};
